import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const SmartSwap: FC<SvgIconProps> = ({ sx, ...props }) => (
  <SvgIcon
    viewBox="0 0 32 32"
    sx={{
      width: '32px',
      height: '32px',
      fill: 'none',
      color: '#B4EB56',
      ...sx,
    }}
    {...props}
  >
    <path
      d="M21.3318 2.6582L18.6641 5.32598L21.3318 7.99376"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M26.6674 5.32905H18.6641" stroke="#B4EB56" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M27.9936 15.9996C27.9924 14.1472 27.5602 12.3205 26.7309 10.6641"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3294 4.30273C7.86931 5.54613 3.99467 10.4001 3.99219 16"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6562 29.3375L13.324 26.6697L10.6562 24.002"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M5.32031 26.6689H13.3236" stroke="#B4EB56" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M3.99656 16C3.9977 17.8524 4.42999 19.6791 5.2592 21.3356"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.6641 27.6973C24.1242 26.4539 27.9988 21.5999 28.0013 16"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.406 11.2499L20.7411 14.5841C21.1164 14.9593 21.3274 15.4682 21.3274 15.9989C21.3274 16.5295 21.1167 17.0385 20.7415 17.4138L17.4073 20.7489C17.0321 21.1242 16.5232 21.3352 15.9926 21.3352C15.4619 21.3352 14.9529 21.1245 14.5777 20.7493L11.2425 17.4151C10.8672 17.0399 10.6562 16.531 10.6562 16.0004C10.6562 15.4697 10.8669 14.9608 11.2421 14.5855L14.5763 11.2503C14.9515 10.875 15.4604 10.6641 15.9911 10.6641C16.5217 10.6641 17.0307 10.8747 17.406 11.2499V11.2499Z"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export const SmartSwapDark: FC<SvgIconProps> = ({ sx, ...props }) => (
  <SvgIcon
    viewBox="0 0 32 32"
    sx={{
      width: '24px',
      height: '24px',
      fill: 'none',
      color: '#B4EB56',
      ...sx,
    }}
    {...props}
  >
    <path
      d="M21.3318 2.6582L18.6641 5.32598L21.3318 7.99376"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M26.6674 5.32905H18.6641" stroke="#090C18" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M27.9936 15.9996C27.9924 14.1472 27.5602 12.3205 26.7309 10.6641"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3294 4.30273C7.86931 5.54613 3.99467 10.4001 3.99219 16"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6562 29.3375L13.324 26.6697L10.6562 24.002"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M5.32031 26.6689H13.3236" stroke="#090C18" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M3.99656 16C3.9977 17.8524 4.42999 19.6791 5.2592 21.3356"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.6641 27.6973C24.1242 26.4539 27.9988 21.5999 28.0013 16"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.406 11.2499L20.7411 14.5841C21.1164 14.9593 21.3274 15.4682 21.3274 15.9989C21.3274 16.5295 21.1167 17.0385 20.7415 17.4138L17.4073 20.7489C17.0321 21.1242 16.5232 21.3352 15.9926 21.3352C15.4619 21.3352 14.9529 21.1245 14.5777 20.7493L11.2425 17.4151C10.8672 17.0399 10.6562 16.531 10.6562 16.0004C10.6562 15.4697 10.8669 14.9608 11.2421 14.5855L14.5763 11.2503C14.9515 10.875 15.4604 10.6641 15.9911 10.6641C16.5217 10.6641 17.0307 10.8747 17.406 11.2499V11.2499Z"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
